var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(-827 -4925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1164",
    "data-name": "Rectangle 1164",
    width: 77,
    height: 77,
    transform: "translate(827 4925)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trading_Card",
    "data-name": "Trading Card",
    transform: "translate(835 4933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M247.123,143.238a4.3,4.3,0,0,0,5.869-1.592l19.4-33.818a4.3,4.3,0,0,0-1.591-5.873L251.731,91.021a4.3,4.3,0,0,0-5.872,1.591l-2.548,4.44v29.076a5.659,5.659,0,0,1-5.652,5.654H227.366a4.331,4.331,0,0,0,.688.522Z",
    transform: "translate(-211.373 -82.841)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M94.852,70.711a4.306,4.306,0,0,0,4.3,4.3h21.984a4.306,4.306,0,0,0,4.3-4.3V31.724a4.306,4.306,0,0,0-4.3-4.3H99.154a4.307,4.307,0,0,0-4.3,4.3Z",
    transform: "translate(-94.852 -27.423)",
    fill: "#016dd9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/Cards.c7cd69dd3189e30e4d4ae1e9328de1c0.svg";
export { ForwardRef as ReactComponent };